import axios, { AxiosError } from "axios";

import { isWebview, refreshToken } from "./webview";

const getAuthorizationCookie = (): string | null => {
  const match = document.cookie.match(/(?:^|;\s*)Authorization=([^;]*)/);

  return match ? decodeURIComponent(match[1]) : null;
};

let refreshTokenPromise: Promise<void> | null = null;

const registerRefreshTokenInterceptor = () => {
  axios.interceptors.response.use(undefined, async (error: AxiosError) => {
    if (error.response?.status !== 401 || !error.config) {
      throw error;
    }

    if (!refreshTokenPromise) {
      refreshTokenPromise = refreshToken().finally(() => {
        refreshTokenPromise = null;
      });
    }

    await refreshTokenPromise;

    const authorization = getAuthorizationCookie();
    axios.defaults.headers.common.Authorization = authorization;
    if (!error.config.headers) {
      error.config.headers = {};
    }
    error.config.headers.Authorization = authorization;

    return axios(error.config);
  });
};

export const initAxios = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API;
  axios.defaults.withCredentials = true;
  axios.defaults.xsrfCookieName = "csrftoken";
  axios.defaults.xsrfHeaderName = "X-CSRFToken";

  if (isWebview(window)) {
    registerRefreshTokenInterceptor();
  }
};
